import React from 'react';
export function TestimonialsSection() {
  return <section className="w-full bg-gray-50 py-8 px-4 border-t border-gray-200" data-id="element-200">
      <div className="max-w-2xl mx-auto" data-id="element-201">
        <h2 className="text-3xl md:text-4xl font-black text-center text-black mb-8" data-id="element-202">
          Lo que dicen otros padres
        </h2>

        <div className="space-y-10" data-id="element-203">
          <blockquote className="border-l-4 border-yellow-400 pl-6" data-id="element-204">
            <p className="text-lg md:text-xl font-bold text-gray-800 italic mb-3 leading-relaxed" data-id="element-205">
              "Antes las tareas eran un caos. Terminábamos los dos enojados. Hoy
              entiendo cómo acompañarlo y todo es mucho más tranquilo."
            </p>
            <p className="font-black text-black" data-id="element-206">— Mariana, mamá de primaria</p>
          </blockquote>

          <blockquote className="border-l-4 border-yellow-400 pl-6" data-id="element-207">
            <p className="text-lg md:text-xl font-bold text-gray-800 italic mb-3 leading-relaxed" data-id="element-208">
              "Sentía que no sabía explicarle nada. Ahora tengo herramientas
              claras y mi hijo está mucho más motivado."
            </p>
            <p className="font-black text-black" data-id="element-209">— Lucas, papá</p>
          </blockquote>

          <blockquote className="border-l-4 border-yellow-400 pl-6" data-id="element-210">
            <p className="text-lg md:text-xl font-bold text-gray-800 italic mb-3 leading-relaxed" data-id="element-211">
              "Pensé que el problema era mi hija, pero era yo la que no sabía
              cómo ayudarla. Este kit me dio la claridad que necesitaba."
            </p>
            <p className="font-black text-black" data-id="element-212">— Sofía R., mamá de Rosario</p>
          </blockquote>
        </div>
      </div>
    </section>;
}